import styled from 'styled-components';
import {
    colorWhite,
    mediaMd,
    mediaSm,
    mediaXs,
} from 'theme/theme-helper-selectors';

export const Disclaimer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 63px;
    color: ${colorWhite};
`;

export const DisclaimerTitle = styled.div`
    font-size: 181px;
    line-height: 162px;
    font-weight: 400;

    @media (${mediaSm}) {
        font-size: 110px;
        line-height: 110px;
    }

    @media (${mediaXs}) {
        font-size: 72px;
        line-height: 65px;
    }
`;

export const DisclaimerSubtitle = styled.div`
    font-size: 32px;
    line-height: 36px;
    font-weight: 400;

    @media (${mediaSm}) {
        font-size: 32px;
        line-height: 36px;
    }

    @media (${mediaXs}) {
        font-size: 24px;
        line-height: 27px;
    }
`;

export const DisclaimerItem = styled.div`
    display: flex;
    flex-direction: row;
    gap: 32px;
    align-items: center;

    &:nth-child(1) {
        ${DisclaimerTitle}, ${DisclaimerSubtitle} {
            background: linear-gradient(
                133.81deg,
                rgba(62, 220, 204, 1),
                rgba(69, 237, 169, 1)
            );
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }

    &:nth-child(2) {
        padding-left: 130px;

        @media (${mediaXs}) {
            padding-left: 0;
        }

        ${DisclaimerTitle}, ${DisclaimerSubtitle} {
            background: linear-gradient(
                135.43deg,
                rgba(124, 153, 251, 1),
                rgba(157, 135, 249, 1)
            );
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }

    &:nth-child(3) {
        ${DisclaimerTitle} {
            margin-right: 60px;

            @media (${mediaMd}) {
                margin-right: 0;
            }
        }

        ${DisclaimerTitle}, ${DisclaimerSubtitle} {
            background: linear-gradient(
                140.6deg,
                rgba(76, 179, 254, 1),
                rgba(151, 138, 249, 1)
            );
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }

    @media (${mediaSm}) {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }
`;

export const DisclaimerDescription = styled.div`
    font-size: 24px;
    line-height: 27px;
    font-weight: 300;
    padding: 8px 0 0 0;
    color: ${colorWhite};
    -webkit-text-fill-color: ${colorWhite};
    opacity: 0.7;

    @media (${mediaXs}) {
        font-size: 14px;
        line-height: 16px;
    }
`;
